import React, { Component } from 'react';
import ReactPlaceholder from 'react-placeholder';
import { InputPlaceholder } from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import EnhancedSelect from './enhanced_select/enhanced_select';
import { handleError } from '../../utils/errors';

class StoryFormatSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storyFormats: []
    };
  }

  componentDidMount() {
    const { onFetching, onError } = this.props;
    onFetching('storyFormats', true);
    return get('/api/v1/story_formats', false)
      .then(res => {
        onFetching('storyFormats', false);
        this.setState({
          storyFormats: res.data
        });
      })
      .catch(error => {
        handleError(error, () => onError());
      });
  }

  render() {
    const { storyFormats } = this.state;
    const { fetching, values, errors, touched } = this.props;
    return (
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!fetching}
      >
        <EnhancedSelect
          {...this.props}
          id="storyFormat"
          selectedValue={values.storyFormat}
          errors={errors.storyFormat}
          touched={touched.storyFormat}
          options={storyFormats}
          label="Story format"
          placeholder="Select a story format"
          required
        />
      </ReactPlaceholder>
    );
  }
}

export default StoryFormatSelect;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/story_format_select.jsx